import styled from "styled-components";
import Width from "../Width";
import HeaderUser from "../HeaderUser";
import { Stack } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet-async"; // Import directly

const HeaderBlock = styled.div`
  width: 100%;
  height: 100px;
  border-bottom: 1px solid #d1d3d4;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.div`
  background: url(/images/am/logo.svg);
  width: 250px;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50%;
`;

const HeaderComponent = () => (
  <HeaderBlock>
    <Helmet>
      <link rel="icon" href="/favicon.ico" />
    </Helmet>

    <Width>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        width="100%"
        height="100%"
        justifyContent="space-between"
      >
        <Logo />

        <HeaderUser />
      </Stack>
    </Width>
  </HeaderBlock>
);

export default HeaderComponent;
